<template>
    <section class="contact-us">
        <div class="container">
            <div class="contact-us__block">
                <p class="h3 form__success" v-if="success">
                    <img
                        class="form__success-img"
                        src="/assets/img/other/snail.png"
                        alt=""
                    />

                    <span class="form__success-text">
                        Заявка успешно отправлена! Мы свяжемся с Вами в
                        ближайшее время.
                    </span>
                </p>

                <form
                    v-if="!success"
                    @submit.prevent="formSubmit"
                    method="POST"
                    class="contact-us__form"
                >
                    <h3 class="contact-us__title">Есть вопросы ?</h3>

                    <p class="contact-us__text">
                        Закажите обратный звонок и мы перезвоним для
                        консультаций через 30 секунд
                    </p>

                    <custom-text
                        v-model="question.name"
                        :v="$v.question.name"
                        placeholder="Ваше имя"
                        errorText="Укажите имя"
                    />

                    <custom-phone
                        v-model="question.phone"
                        :v="$v.question.phone"
                        errorText="Укажите корректный номер"
                        placeholder="Номер телефона"
                    />
                    <!-- class="input input__text input__bigger" -->

                    <button class="btn _primary _big" type="submit">
                        Оставить заявку
                    </button>

                    <p class="contact-us__text _center">
                        Нажимая на кнопку я даю согласие на обработку
                        персональных данных
                    </p>
                </form>

                <div class="contact-us__info">
                    <div class="contact-us__contact">
                        <h3 class="contact-us__title">Наши контакты</h3>
                        <a class="contact-item" href="tel:+73833331999">
                            <span class="_icon">
                                <img
                                    src="/assets/img/automatize/icons/contact-phone.svg"
                                    alt=""
                                />
                            </span>
                            <span class="_content">
                                <span class="_title">+7 (383) 333-19-99</span>
                                <span>Единая линия: 10:00-20:00</span>
                            </span>
                        </a>

                        <a class="contact-item" href="mailto:info@rolatex.ru">
                            <span class="_icon">
                                <img
                                    src="/assets/img/automatize/icons/contact-mail.svg"
                                    alt=""
                                />
                            </span>
                            <span class="_title">info@rolatex.ru</span>
                        </a>
                    </div>

                    <div class="contact-us__social">
                        <h3 class="contact-us__title">Мы в соц. сетях</h3>
                        <a class="_item" target="_blank" href="https://t.me/rolatex_official_bot">
                            <svg>
                                <use
                                    xlink:href="/assets/img/sprite.svg#telegram"
                                />
                            </svg>
                        </a>

                        <a class="_item" target="_blank" href="https://api.whatsapp.com/send?phone=79139486501">
                            <svg>
                                <use
                                    xlink:href="/assets/img/sprite.svg#whatsapp"
                                />
                            </svg>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import inputText from './common/inputText';
import inputPhone from './common/inputPhone';
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

export default {
    name: 'questionForm',
    components: { inputText, inputPhone },

    data() {
        return {
            question: {
                name: null,
                phone: null,
                type: 'automatize-question',
                recaptcha: null,
            },
            success: false,
        };
    },
    validations: {
        question: {
            name: {
                required,
                minLength: minLength(2),
            },
            phone: {
                required,
                minLength: minLength(18),
                maxLength: maxLength(18),
                correctAddress(phone) {
                    return /^((8|\+7)[\- ]?)?(\(?\d{3}\)?[\- ]?)?[\d\- ]{7,10}$/.test(
                        phone
                    );
                },
            },
        },
    },

    computed:{
        cityData() {
            return this.$store.getters.currentCityData;
        },
    },

    methods: {
        formSubmit() {
            this.$v.question.$touch();
            if (this.$v.question.$pending || this.$v.question.$error) {
            } else {
                this.recaptcha().then((token) => {
                    this.question.recaptcha = token;
                    this.question.url = window.location.href;
                    this.$http
                        .post('/api/forms/callback/automatize', this.question)
                        .then((res) => {});
                    this.success = true;
                    ym(1980352, 'reachGoal', 'callback');
                });
            }
        },
    },
};
</script>
